<template>
  <section class="lista">
    <!-- Busca -->
    <div class="busca">
      <div class="nome">
        <div class="icone">
          <Svgs nome="curso" />
        </div>
        <p>{{ storeCursos.cursos?.length }} cursos</p>
      </div>
      <div class="input">
        <Svgs class="icone" nome="lupa" />
        <form autocomplete="off">
          <input type="text" name="fakeuser" style="display: none" />
          <input type="password" name="fakepassword" style="display: none" />
          <input type="text" placeholder="Buscar curso..." autocomplete="off" spellcheck="false" v-model="searchQuery" />
        </form>
      </div>
      <div class="select">
        <Svgs nome="setinha" />
        <select v-model="selectedFilter">
          <option value="todos">Todas</option>
          <option value="alfabetica-asc">Alfabética A-Z</option>
          <option value="alfabetica-desc">Alfabética Z-A</option>
          <option value="mais-antigos">Mais antigas</option>
          <option value="mais-novos">Mais novas</option>
        </select>
      </div>
      <button class="reorganizar" @click="ativarDrag()" v-if="!state.reordenando">
        <Svgs nome="posicao" />
        <p>Reordenar</p>
      </button>
      <button class="reorganizar" @click="salvarNovaPosicao()" :disabled="state.salvandoPosicoes" v-else>
        <Svgs nome="posicao" />
        <p>Salvar</p>
        <span></span>
      </button>
      <button class="adicionar" @click="novoCurso()">
        <Svgs nome="mais" />
        <p>Curso</p>
      </button>
    </div>
    <!-- Itens -->
    <div ref="listaRef" class="itens" :class="{ reordenando: state.reordenando }">
      <div class="balao" v-if="state.balao.visivel" :style="state.balao.posicao" ref="balao">
        <button @click="abrirModulos(state.balao?.curso?._id)">
          <Svgs nome="play" />
          <p>Ver módulos</p>
        </button>
        <button @click="editar(state.balao?.curso)">
          <Svgs nome="editar" />
          <p>Editar</p>
        </button>
        <button @click="duplicar(state.balao.curso?._id)" :disabled="state.carregandoDuplicar">
          <Svgs nome="duplicar" />
          <p>Duplicar</p>
          <span></span>
        </button>
        <button @click="copiarLink(state.balao?.curso)">
          <Svgs nome="link" />
          <p>Copiar link</p>
        </button>
        <button class="excluir" @click="toggleExcluir(state.balao?.curso?._id)">
          <Svgs nome="excluir" />
          <p>Excluir curso</p>
        </button>
        <div class="exclusao" :class="{ mostrar: exclusaoAtivo === state.balao?.curso?._id }">
          <p>Deseja excluir?</p>
          <div class="opcoes">
            <button class="confirmar" @click="confirmarExclusao(state.balao?.curso?._id)" :disabled="state.excluindo">
              Sim
              <span></span>
            </button>
            <button class="cancelar" @click="toggleExcluir(state.balao?.curso?._id)">Cancelar</button>
          </div>
        </div>
      </div>
      <div
        class="item"
        v-for="curso in cursosFiltrados"
        @contextmenu.prevent="abrirBalao($event, curso)"
        :key="curso._id"
        :class="{
          ativo: cursoAtivo === curso._id || state.balao?.curso?._id === curso._id
        }">
        <div class="informacoes" @click="abrirModulos(curso._id)">
          <div class="capa">
            <div class="tamanho">
              <div class="imagem" :style="`background-image: url('${curso.imagemCapa || 'https://central-statics.nyc3.digitaloceanspaces.com/unicmodulos/imagens/global/placeholder.png'}')`"></div>
            </div>
          </div>
          <div class="nome">
            <div class="titulo">
              <h3>{{ helperTexto.limitarCaracteres(curso.nome, 55) }}</h3>
            </div>
            <p>{{ helperTexto.limitarCaracteres(curso.descricao, 55) }}</p>
          </div>
        </div>
        <div class="duracao">
          <Svgs nome="usuarios" />
          <p>{{ curso.quantidadeAlunos }} alunos</p>
        </div>
        <div class="status">
          <Svgs nome="modulo" />
          <h3>{{ curso.quantidadeModulos }} módulos</h3>
        </div>
        <button class="abrir" @click="abrirBalaoClique(curso)">
          <Svgs nome="bolinhas" />
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, ref, watch, onUnmounted, reactive, onBeforeUnmount, inject, nextTick } from 'vue'
import { useStoreAreas, useStoreCursos, useStoreModulos, useStoreModal } from '@stores'
import { helperTexto } from '@helpers'
import { Sortable } from '@shopify/draggable'
import Svgs from '@svgs'

const storeAreas = useStoreAreas()
const storeCursos = useStoreCursos()
const storeModulos = useStoreModulos()
const storeModal = useStoreModal()

const emitter = inject('emitter')
const searchQuery = ref('')
const selectedFilter = ref('todos')
const dadosCarregados = ref(false)
const cursoAtivo = ref(null)
const exclusaoAtivo = ref(null)
const balao = ref(null)

const listaRef = ref(null)
let sortableInstance = null

const state = reactive({
  reordenando: false,
  posicaoAlterada: false,
  salvandoPosicoes: false,
  carregandoDuplicar: false,
  excluindo: false,
  balao: {
    visivel: false,
    posicao: { top: '0px', left: '0px' },
    curso: null
  }
})

const abrirBalaoClique = (curso) => {
  const listaRect = document.querySelector('.itens').getBoundingClientRect()

  const y = event.clientY - listaRect.top

  state.balao = {
    visivel: true,
    curso,
    posicao: { top: `${y + 100}px`, right: '30px' }
  }

  nextTick(() => {
    document.addEventListener('click', cliqueForaBalao)
  })
}

const abrirBalao = (event, curso) => {
  const listaRect = document.querySelector('.itens').getBoundingClientRect()

  const x = event.clientX - listaRect.left
  const y = event.clientY - listaRect.top

  state.balao = {
    visivel: true,
    curso,
    posicao: { top: `${y + 100}px`, left: `${x}px` }
  }

  nextTick(() => {
    if (balao.value) {
      const balaoRect = balao.value.getBoundingClientRect()
      if (x + balaoRect.width > listaRect.width) state.balao.posicao.left = `${listaRect.width - balaoRect.width - 20}px`
      if (y + balaoRect.height > listaRect.height) state.balao.posicao.top = `${listaRect.height - balaoRect.height - 20}px`
      if (y < 0) state.balao.posicao.top = '20px'
    }

    document.addEventListener('click', cliqueForaBalao)
  })
}

const fecharBalao = () => {
  state.balao.visivel = false
  state.balao.curso = null
  document.removeEventListener('click', cliqueForaBalao)
}

const cliqueForaBalao = (event) => {
  const isButtonClick = event.target.closest('.abrir')

  if (isButtonClick) {
    return
  }

  if (balao.value && !balao.value.contains(event.target)) {
    fecharBalao()
  }
}

function copiarLink(curso) {
  const hotlinkArea = storeAreas.area.hotlink
  const hotlinkCurso = curso.hotlink
  const dominioPersonalizado = storeAreas.area.dominioPersonalizado

  let link = dominioPersonalizado ? `https://${dominioPersonalizado}/${hotlinkArea}/curso/${hotlinkCurso}` : `https://mber.live/${hotlinkArea}/curso/${hotlinkCurso}`

  navigator.clipboard
    .writeText(link)
    .then(() => {
      emitter.emit('mostrarAlerta', {
        tipo: 'positivo',
        mensagem: 'Link copiado com sucesso!'
      })
      fecharBalao()
    })
    .catch((error) => {
      console.error('Erro ao copiar:', error)
      emitter.emit('mostrarAlerta', {
        tipo: 'negativo',
        mensagem: 'Erro ao copiar o link'
      })
    })
}

const cursosFiltrados = computed(() => {
  let cursos = storeCursos.cursos || []

  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    cursos = cursos.filter((curso) => {
      return curso.nome?.toLowerCase().includes(query) || curso.descricao?.toLowerCase().includes(query)
    })
  }

  switch (selectedFilter.value) {
    case 'alfabetica-asc':
      cursos = cursos.slice().sort((a, b) => a.nome.localeCompare(b.nome))
      break
    case 'alfabetica-desc':
      cursos = cursos.slice().sort((a, b) => b.nome.localeCompare(a.nome))
      break
    case 'mais-antigos':
      cursos = cursos.slice().sort((a, b) => new Date(a.dataRegistro) - new Date(b.dataRegistro))
      break
    case 'mais-novos':
      cursos = cursos.slice().sort((a, b) => new Date(b.dataRegistro) - new Date(a.dataRegistro))
      break
  }

  return cursos
})

function toggleExcluir(id) {
  if (exclusaoAtivo.value === id) {
    exclusaoAtivo.value = null
    state.excluindo = false
  } else {
    exclusaoAtivo.value = id
  }
}

function novoCurso() {
  storeModal.abrirModal('criarCurso', 'curso', 'Criar curso')
}

async function abrirModulos(idCurso) {
  emitter.emit('iniciarCarregamento')
  const idArea = storeAreas.area._id

  await storeModulos.receberTodos(idArea, idCurso)
  await storeCursos.receberPorId(idArea, idCurso)
  emitter.emit('pararCarregamento')
}

function editar(curso) {
  storeModal.abrirModalEdicao('editarCurso', 'editar', 'Editar curso', curso)
}

async function confirmarExclusao(idCurso) {
  state.excluindo = true
  const idArea = storeAreas.area._id

  const delecaoOk = await storeCursos.deletar(idArea, idCurso)
  if (delecaoOk !== true) return

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: 'Curso excluído com sucesso' })
  emitter.emit('atualizarCursos')
  state.excluindo = false
  fecharBalao()
}

async function duplicar(idCurso) {
  state.carregandoDuplicar = true

  const idArea = storeAreas.area._id

  const duplicacaoOk = await storeCursos.duplicar(idArea, idCurso)
  if (duplicacaoOk !== true) return

  emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Curso duplicado com sucesso' })
  emitter.emit('atualizarCursos')
  state.carregandoDuplicar = false
  fecharBalao()
}

const ativarDrag = () => {
  state.reordenando = true
  iniciarSortable()
}

const iniciarSortable = () => {
  if (sortableInstance) sortableInstance.destroy()

  sortableInstance = new Sortable(listaRef.value, {
    draggable: '.item',
    mirror: { constrainDimensions: true }
  })

  sortableInstance.on('sortable:sorted', (event) => {
    const { oldIndex, newIndex } = event
    const movedItem = cursosFiltrados.value.splice(oldIndex, 1)[0]
    cursosFiltrados.value.splice(newIndex, 0, movedItem)
    state.posicaoAlterada = true
  })
}

const salvarNovaPosicao = async () => {
  state.salvandoPosicoes = true
  const payload = {
    ids: cursosFiltrados.value.map((curso) => curso._id)
  }

  const idArea = storeAreas.area._id

  const posicoesOk = await storeCursos.ordenarPosicoes(idArea, payload)
  if (posicoesOk !== true) return

  destruirSortable()
  state.reordenando = false
  state.posicaoAlterada = false
  state.salvandoPosicoes = false
  emitter.emit('atualizarCursos')
}

const destruirSortable = () => {
  if (sortableInstance) {
    sortableInstance.destroy()
    sortableInstance = null
  }
}

onBeforeUnmount(() => {
  destruirSortable()
})

onUnmounted(() => {
  document.removeEventListener('click', cliqueForaBalao)
})

watch(
  () => storeCursos.cursos,
  (newModulos) => {
    dadosCarregados.value = !!newModulos && newModulos.length >= 0
  },
  { immediate: true }
)
</script>

<style scoped>
section.lista {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  position: relative;
}
.busca {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 20px 0;
}
.busca .nome {
  display: flex;
  align-items: center;
  min-width: 160px;
}
.busca .nome .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  background-color: var(--cor-escuro-2);
}
.busca .nome .icone svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-branco);
}
.busca .nome p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  margin: 0 0 0 10px;
}
.busca .input {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}
.busca .input form {
  width: 100%;
}
.busca .input input {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  padding: 15px 20px 15px 40px;
  background-color: var(--cor-escuro-2);
  border-radius: 8px;
  width: 100%;
  transition: all 0.3s;
}
.busca .input input::placeholder {
  color: var(--cor-escuro-5);
}
.busca .input input:focus {
  background-color: var(--cor-escuro-3);
}
.busca .input svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-6);
  position: absolute;
  left: 15px;
  pointer-events: none;
}
.busca .select {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 370px;
  margin: 0 10px;
}
.busca .select select {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  padding: 15px 20px;
  background-color: var(--cor-escuro-2);
  border-radius: 8px;
  width: 100%;
  appearance: none;
  transition: all 0.3s;
}
.busca .select select::placeholder {
  color: var(--cor-escuro-5);
}
.busca .select select:focus {
  background-color: var(--cor-escuro-3);
}
.busca .select svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-6);
  position: absolute;
  right: 15px;
  pointer-events: none;
}
.busca .reorganizar {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 350px;
  padding: 15px 20px;
  background-color: var(--cor-escuro-2);
  border-radius: 8px;
  position: relative;
  transition: all 0.3s;
}
.busca .reorganizar:hover {
  background-color: var(--cor-escuro-3);
}
.busca .reorganizar:hover p {
  color: var(--cor-branco);
}
.busca .reorganizar:hover svg {
  fill: var(--cor-branco);
}
.busca .reorganizar p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.busca .reorganizar svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-6);
  margin: 0 10px 0 0;
  transition: all 0.3s;
}
.busca .reorganizar span {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--cor-branco);
  border-top: 2px solid transparent;
  animation: girando 1s linear infinite;
  opacity: 0;
  visibility: hidden;
}
.busca .reorganizar:disabled {
  pointer-events: none;
}
.busca .reorganizar:disabled span {
  opacity: 1;
  visibility: visible;
}
.busca .reorganizar:disabled p {
  color: transparent;
}
.busca .reorganizar:disabled svg {
  fill: transparent;
}
.busca button.adicionar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco-fixo);
  padding: 15px 20px;
  background-color: var(--cor-marca);
  border-radius: 8px;
  width: 320px;
  margin: 0 0 0 10px;
  transition: all 0.3s;
}
.busca button.adicionar:hover {
  background-color: var(--cor-marca-escuro);
}
.busca button.adicionar svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-branco-fixo);
  margin: 0 10px 0 0;
}
.balao {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  width: 190px;
  min-width: 190px;
  background-color: var(--cor-escuro-2);
  border: 2px solid var(--cor-escuro-3);
  border-radius: 8px;
  padding: 10px 15px;
  z-index: 10;
  animation: fadeIn 0.3s linear;
}
.balao button {
  display: flex;
  align-items: center;
  padding: 7px 0;
  background-color: transparent;
}
.balao button svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-escuro-6);
  margin: 0 10px 0 0;
  transition: all 0.3s;
}
.balao button p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.balao button:hover p {
  color: var(--cor-branco);
}
.balao button:hover svg {
  fill: var(--cor-branco);
}
.balao button.excluir svg {
  fill: var(--cor-vermelho);
}
.balao button.excluir p {
  color: var(--cor-vermelho);
}
.balao button.excluir:hover svg {
  fill: var(--cor-branco);
}
.balao button.excluir:hover p {
  color: var(--cor-branco);
}
.balao button:disabled svg {
  fill: transparent;
}
.balao button:disabled span {
  opacity: 1;
  visibility: visible;
}
.balao button span {
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid var(--cor-branco);
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: girando 1s linear infinite;
  left: auto;
  opacity: 0;
  visibility: hidden;
}
.itens {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  overflow-y: scroll;
  max-height: calc(100dvh - 200px);
  transition: all 0.3s;
  scrollbar-width: none;
}
.itens::-webkit-scrollbar {
  display: none;
}
.itens.reordenando {
  border: 2px dashed var(--cor-escuro-3);
  padding: 20px;
}
.itens.reordenando .item {
  cursor: grab !important;
  user-select: none;
}
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--cor-escuro-2);
  border: 1px solid var(--cor-escuro-2);
  border-radius: 8px;
  margin: 0 0 20px 0;
  position: relative;
  user-select: none;
  transition: all 0.3s;
}
.item.ativo {
  border: 1px solid var(--cor-escuro-4);
}
.item .antigo {
  display: flex;
  align-items: center;
  margin: 0 0 0 10px;
}
.item .antigo svg {
  width: 8px;
  min-width: 8px;
  fill: var(--cor-laranja);
  margin: 0 5px 0 0;
}
.item .antigo h4 {
  font-family: var(--medium);
  font-size: var(--f0);
  color: var(--cor-laranja);
}
.item .informacoes {
  display: flex;
  align-items: center;
  margin-right: auto;
  cursor: pointer;
  transition: all 0.3s;
}
.item .informacoes:hover {
  transform: scale(1.05);
}
.item .capa {
  width: 130px;
  min-width: 130px;
}
.item .capa .tamanho {
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 56.52%;
  overflow: hidden;
}
.item .capa .tamanho .imagem {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--cor-escuro-3);
  border-radius: 8px;
  background-size: cover;
  background-position: center;
}
.item .capa .tamanho .imagem .normal {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
}
.item .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 20px;
}
.item .nome .titulo {
  display: flex;
  align-items: center;
}
.item .nome h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  line-height: 1.5;
}
.item .nome p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  line-height: 1.5;
  margin: 5px 0 0 0;
}
.item .status {
  display: flex;
  align-items: center;
  background-color: #0dc78f10;
  padding: 6px 10px;
  border-radius: 50px;
  margin: 0 20px 0 0;
}
.item .status svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-verde);
  margin: 0 5px 0 0;
}
.item .status h3 {
  font-family: var(--bold);
  font-size: var(--f0);
  color: var(--cor-verde);
}
.item .duracao {
  display: flex;
  align-items: center;
  background-color: var(--cor-escuro-3);
  padding: 6px 10px;
  border-radius: 50px;
  margin: 0 20px 0 0;
}
.item .duracao svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-escuro-6);
  margin: 0 5px 0 0;
}
.item .duracao p {
  font-family: var(--bold);
  font-size: var(--f0);
  color: var(--cor-escuro-6);
}
.itens .item.ativo button.abrir {
  background-color: var(--cor-escuro-4);
}
.item button.abrir {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background-color: var(--cor-escuro-3);
  margin: 0 20px 0 0;
  transition: all 0.3s;
}
.item button.abrir:hover {
  background-color: var(--cor-escuro-4);
}
.item button.abrir svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-branco);
}
.exclusao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: var(--cor-escuro-2);
  border: 2px solid var(--cor-escuro-3);
  padding: 15px;
  z-index: 3;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s;
}
.exclusao.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.exclusao p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
  line-height: 1.5;
  text-align: center;
  margin: 0 0 10px 0;
}
.exclusao .opcoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.exclusao .opcoes button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--medium);
  font-size: var(--f1);
  text-align: center;
  width: calc(50% - 3px);
  padding: 10px;
  border-radius: 10px;
  position: relative;
  transition: all 0.3s;
}
.exclusao .opcoes button.confirmar:disabled {
  color: transparent;
}
.exclusao .opcoes button.confirmar:disabled span {
  opacity: 1;
  visibility: visible;
}
.exclusao .opcoes button.confirmar span {
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid var(--cor-branco);
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: girando 1s linear infinite;
  left: auto;
  opacity: 0;
  visibility: hidden;
}
.exclusao .opcoes button.confirmar {
  background-color: var(--cor-vermelho);
  color: var(--cor-branco-fixo);
}
.exclusao .opcoes button.confirmar:hover {
  background-color: var(--cor-vermelho-escuro);
  opacity: 1;
}
.exclusao .opcoes button.cancelar {
  background-color: var(--cor-escuro-4);
  color: var(--cor-branco);
}
.exclusao .opcoes button.cancelar:hover {
  background-color: var(--cor-escuro-5);
  opacity: 1;
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  section.lista {
    height: calc(100dvh - 130px);
  }
  .busca {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 0 20px 0;
  }
  .busca .input {
    width: calc(60% - 5px);
  }
  .busca .input input {
    padding: 12px 12px 12px 30px;
  }
  .busca .input svg {
    width: 12px;
    min-width: 12px;
    left: 12px;
  }
  .busca .select {
    width: calc(40% - 5px);
  }
  .busca .select select {
    padding: 12px 15px;
  }
  .busca .select svg {
    width: 12px;
    min-width: 12px;
    right: 12px;
  }
  .busca .reorganizar {
    display: none;
  }
  .item {
    flex-direction: column;
    align-items: flex-start;
    margin: 0 0 15px 0;
    padding: 15px;
    position: relative;
  }
  .item .informacoes {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .item .nome .titulo {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
  .item .nome .antigo {
    margin: 0 0 10px 0;
  }
  .item .capa {
    width: 100px;
    min-width: 100px;
  }
  .item .nome {
    padding: 15px 0 10px 0;
  }
  .item .nome:hover {
    opacity: 0.8;
  }
  .item .status {
    margin: 15px 0 0 0;
  }
  .item .links {
    margin: 0;
  }
  .item button.abrir {
    position: absolute;
    top: 10px;
    right: 10px;
    margin: 0;
  }
  .itens .item .botoes .lista {
    width: 180px;
    min-width: 180px;
  }
  .itens .item .botoes .lista button p {
    font-size: var(--f1);
  }
}
</style>
